export const formatedDate = (date) => {
    const d = new Date(date);
    return `${d.getUTCFullYear()}-${(d.getUTCMonth()+1).toString().padStart(2, "0")}-${d.getUTCDate().toString().padStart(2, "0")}`;
}

export const formatedTime = (date) => {
    const d = new Date(date);
    return `${d.getUTCHours().toString().padStart(2, "0")}:${d.getUTCMinutes().toString().padStart(2, "0")}`;
}
